import { useSyncExternalStore } from "react";
import {
  isDemoModeActive,
  subscribeDemoMode,
  enableDemoMode,
  disableDemoMode,
} from "@/lib/demoMode";

export function useDemoMode() {
  const active = useSyncExternalStore(
    subscribeDemoMode,
    isDemoModeActive,
    () => false,
  );
  return { active, enable: enableDemoMode, disable: disableDemoMode };
}
